import { ticketComponent } from './ticket.component';
import { TicketService } from './ticket.service';

export const ticketStateName = 'app.ticket';

export const ticketState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: ticketStateName,
    url: '/tickets/:ticketId?product',
    component: ticketComponent.name,
    data: { requiresAuth: true },
    resolve: {
      aidRequest: TicketService.aidRequest(),
      ticketId: TicketService.ticketId(),
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const tenant = envService.getTenant();
        if (tenant === 'ATRUVIA_UI' && !envService.isLocalhost()) {
          $window.location.href = $window.location.href.replace(
            '/tickets',
            '/v2/tickets',
          );
        }
      },
    },
  });
};
